<div class="d-flex flex-column align-items-center">
  <div
    class="info-container px-5 d-flex flex-column align-items-center justify-content-center"
  >
    <h1 class="text-center">{{ item.titleTranslationKey }}</h1>
    <p class="text-muted text-center">
      {{ item.descriptionTranslationKey }}
    </p>
  </div>
  <div class="media-container w-100 d-flex justify-content-center">
    <atx-media-preview
      class="w-100"
      objectFit="contain"
      [media]="{ url: item.mediaUrl, mediaType: item.mediaType }"
      [activateMedia]="isActive"
      [videoAttributes]="{
        muted: true,
        controls: false,
        disablePlaceholder: true
      }"
    ></atx-media-preview>
  </div>
</div>
